import React, { useEffect } from 'react';
import RegisterContainer from './register/RegisterContainer';

function Register() {
  useEffect(() => {
    // Add register-page class to body when component mounts
    document.body.classList.add('register-page');
    
    // Remove the class when component unmounts
    return () => {
      document.body.classList.remove('register-page');
    };
  }, []);

  return <RegisterContainer />;
}

export default Register; 